import { isEqual } from 'lodash/fp';

import { getHomepageRoot } from '../../../store/rootSelector';
import { ApplicationState } from '../../../store/types';
import { CustomFilters, HomePageChart, UserDefaults } from '../../auth/login/store/types';
import { Continent, Country } from '../../documents/analytics/store/types';
import { PieChartAnalyticsData } from '../../shared/analytics/PieChart';
import { ArkModule, EntityJurisdictionAnalytics, MyAttestationAnalytics, MyProfileSection } from './types';

export const getFetchingAnalytics = (state: ApplicationState): HomePageChart[] => getHomepageRoot(state).homepageFetchingAnalytics;

export const getDocumentSpreadAnalytics = (state: ApplicationState): PieChartAnalyticsData[] => getHomepageRoot(state).documentSpread;

export const getEntitySpreadAnalytics = (state: ApplicationState): PieChartAnalyticsData[] => getHomepageRoot(state).entitySpread;

export const getHomeEntitySpreadAnalytics = (state: ApplicationState): PieChartAnalyticsData[] => getHomepageRoot(state).homeEntitySpread;

export const getMyAttestationProgressAnalytics = (state: ApplicationState): MyAttestationAnalytics[] => getHomepageRoot(state).myAttestationProgress;

export const getCounterpartyJurisdictionAnalytics = (state: ApplicationState): EntityJurisdictionAnalytics[] => getHomepageRoot(state).entityJurisdiction;

export const getWorldGeometryJSON = (state: ApplicationState): Country[] => getHomepageRoot(state).worldGeometryJSON;

export const getContinentGeometryJSON = (state: ApplicationState): Continent[] => getHomepageRoot(state).continentGeometryJSON;

export const getUKGeometryJSON = (state: ApplicationState): Country | undefined => getWorldGeometryJSON(state).find(({ id }) => id === 'GBR');

export const getUnauthorisedModuleModalOpen = (state: ApplicationState): boolean => getHomepageRoot(state).unauthorisedModuleModalOpen;

export const getUserNotPermittedModalOpen = (state: ApplicationState): boolean => getHomepageRoot(state).userNotPermittedModalOpen;

export const getUnauthorisedModule = (state: ApplicationState): ArkModule | null => getHomepageRoot(state).unauthorisedModule;

export const getAddNewFilterModalOpen = (state: ApplicationState): boolean => getHomepageRoot(state).addNewFilterModalOpen;

export const getNewCustomFilter = (state: ApplicationState): CustomFilters | null => getHomepageRoot(state).newCustomFilter;

export const getSavedUserCustomFilters = (state: ApplicationState): CustomFilters[] => getHomepageRoot(state).savedUserCustomFilters;

export const getCurrentUserCustomFilters = (state: ApplicationState): CustomFilters[] => getHomepageRoot(state).currentUserCustomFilters;

export const getFilterTileModalOpen = (state: ApplicationState): string | null => getHomepageRoot(state).filterTileModalOpen;

export const getIsSavingCustomFilters = (state: ApplicationState): boolean => getHomepageRoot(state).isSavingCustomFilters;

export const getCustomFiltersUpdated = (state: ApplicationState): boolean => getHomepageRoot(state).customFiltersUpdated;

export const getOnCloseConfirmationDialog = (state: ApplicationState): boolean => getHomepageRoot(state).onCloseConfirmationDialog;

export const getMyProfileSection = (state: ApplicationState): MyProfileSection => getHomepageRoot(state).myProfileSection;

export const getSelectedCustomFilter = (state: ApplicationState): CustomFilters | null => getHomepageRoot(state).selectedCustomFilter;

export const getSavedUserDefaults = (state: ApplicationState): UserDefaults => getHomepageRoot(state).savedUserDefaults;

export const getCurrentUserDefaults = (state: ApplicationState): UserDefaults => getHomepageRoot(state).currentUserDefaults;

export const getUserDefaultsUpdated = (state: ApplicationState): boolean => {
    const savedDefaults = getSavedUserDefaults(state);
    const currentDefaults = getCurrentUserDefaults(state);
    return !isEqual(savedDefaults, currentDefaults);
};

export const getUnsavedProfileChangesModalOpen = (state: ApplicationState): boolean => getHomepageRoot(state).unsavedProfileChangesModalOpen;
